export const FORMSPREE_CONTACT_URL = "https://formspree.io/f/xdarbeol";
export const WHATSAPP_NUMBER = "92332189197";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;
export const EMAIL = "info@onlinequranuniverse.com";
export const PHONE = "+923325189197";
export const LOCATION = "Bahria Town";
export const MAPS_URL = "https://maps.google.com/?q=Bahria%20Town";
